import axios from "axios";
import * as qs from "qs";
import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";

export const SearchCandidateService = {
    getSearchCandidate,
    inviteSelectedCandidates,
    sendEmail,
    sendSms,
    getEmailTemplate,
    getSmsTemplate,
}
function getSearchCandidate(emailPhoneKeywords,firstName,lastName,distance,location,state,peerraters,days,employerJobId,totalSkillIds,languageIds,itemsPerPage,
    currentPage,latitude,longitude){
    return axiosInterceptors.get(ENV.elasticSearch_url+"employer/search/job/candidates",{
        params:{
          employerJobId:employerJobId,
          search:emailPhoneKeywords,
          firstName:firstName,
          lastName:lastName,
          location:location,
          state:state,
          peerraters:peerraters,
          days:days,
          distance:distance,
          skillIds:totalSkillIds,
          languageIds:languageIds,
          ps: itemsPerPage,
          pn: currentPage,
          latitude:latitude,
          longitude:longitude
        },
        paramsSerializer: (params) => {
          var qps = qs.stringify(params, { arrayFormat: "repeat" });
          return qps;
        },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  }
  function  inviteSelectedCandidates(inviteList){
    return axiosInterceptors.get(ENV.elasticSearch_url+ "employer/search/job/matching/candidates",{
      params:{
        ids:inviteList
      },
      paramsSerializer: (params) => {
        var qps = qs.stringify(params, { arrayFormat: "repeat" });
        return qps;
      },
    })
    .then((response)=>{
         return response
    })
    .catch((error)=>{
         return error
    })
  }

  function sendEmail(obj) {
    return axiosInterceptors
      .post(ENV.email_send,obj)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
  
  function sendSms(obj) {
    return axiosInterceptors
      .post(ENV.sms_send,obj)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }

    function getEmailTemplate() {
      return axiosInterceptors
        .get(ENV.messaging_email_app_url)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    }

    function getSmsTemplate() {
      return axiosInterceptors
        .get(ENV.messaging_sms_app_url)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    }
  